<template>
  <v-dialog v-model="showDialog" width="500" v-on:click:outside="onClose">
    <v-card class="non-unique-modal">
      <v-card-title>
        <div />
        <h2>Uh-oh.</h2>
        <button @click="onClose">
          <v-icon>mdi-close</v-icon>
        </button>
      </v-card-title>
      <p v-if="!recoverable">It looks like {{email}} is linked to an existing ASCA web account. Please enter a unique email to continue setting up your account.</p>
      <p v-else>It looks like {{email}} already exists but can be recovered <a v-on:click="onRecover">here</a>.</p>
      <p>If you are attempting to create a new web account and previously used this email, please contact the ASCA Business Office at <a href="mailto:support@asca.org">support@asca.org</a>.</p>
      <v-text-field
        outlined
        required
        label="Email"
        type="email"
        v-model="newEmail"
        :error-messages="validEmail == null || validEmail ? null : ['Email must be valid']"
        :rules="[(v) => !!v || 'Email is required']"
      ></v-text-field>
      <v-btn
        :dark="validEmail"
        large
        color="primary"
        v-on:click="internalOnCheck()"
        :disabled="!validEmail"
      >Next</v-btn>
      <p v-if="!loggedIn">Already have an account? <a href="/login">Login</a></p>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import { debounce } from "throttle-debounce";

import validateEmail from '@/helpers/validate-email';

export default Vue.extend({
  name: 'UniqueEmailDialog',
  props: {
    showDialog: {type: Boolean},
    onClose: {type: Function},
    onCheck: {type: Function},
    onRecover: {type: Function},
    email: {type: String},
    recoverable: {type: Boolean},
    loggedIn: {type: Boolean},
  },
  data() {
    return {
      newEmail: '',
      validEmail: null,
    }
  },
  methods: {
    internalOnCheck() {
      if (!validateEmail(this.newEmail)) {
        (this.validEmail as any) = false;
        return;
      }

      this.onCheck(this.newEmail);
    },
  },
  watch: {
    newEmail: {
      handler: debounce(
        500,
        function (this: any, newVal: string, oldVal: string) {
          if (newVal === oldVal || !newVal) return;

          if (!newVal) this.validEmail = null;
          else this.validEmail = validateEmail(newVal);
        }
      ),
      deep: true,
    },
  }
});
</script>